import React from 'react';
import clsx from 'clsx';

const CustomBadge = ({ title = '', active = false, styles = {} }) => (
  <div
    className={clsx('custom-badge', { ['custom-badge-active']: active })}
    style={styles ? styles : {}}
  >
    {title.toUpperCase()}
  </div>
);

export default CustomBadge;
